import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useNavigate } from '@tanstack/react-router';
import { XCircle } from 'lucide-react';

export function Error(props: { error: Error }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-6">
            <XCircle className="h-16 w-16 text-red-400" />
          </div>
          <CardTitle className="text-2xl">An error occurred</CardTitle>
          <CardDescription>
            We apologize for the inconvenience. Please try again later.
            {import.meta.env.DEV && (
              <pre>{JSON.stringify(props.error.message, null, 2)}</pre>
            )}
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="flex flex-row gap-2 justify-center">
            <Button
              onClick={() => navigate({ to: '/logout' })}
              variant="default"
            >
              Login
            </Button>
            <Button onClick={() => navigate({ to: '..' })} variant="outline">
              Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
